import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ParticipantId } from 'src/app/components/participant/store/participant.model';

@Component({
  selector: 'app-projet-professionnel-preconisation',
  templateUrl: './projet-professionnel-preconisation.component.html',
  styleUrls: ['./projet-professionnel-preconisation.component.scss'],
})
export class ProjetProfessionnelPreconisationComponent implements OnInit {
  @Input() participant: ParticipantId | any = null;
  @Input() projetprofessionnel$ = new BehaviorSubject<any>(null);

  constructor() {}

  ngOnInit(): void {}
}
